import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_settlement_method_link_RowClass} from '../../../dbschema';

export class WebsiteSettlementMethodLinkContainerModel extends BaseContainerModel {
  bl_cms_website_settlement_method_link: bl_cms_website_settlement_method_link_RowClass = new bl_cms_website_settlement_method_link_RowClass();
}
